<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">

  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista==='ListaPedidos'"
                    [innTemplateButton]="innTemplateButtonPedidos"
                    [innTemplate]="enviarTemplatePedidos" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButtonPedidos>
  </ng-template>
  <ng-template #enviarTemplatePedidos>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [loading]="loading"
                                 [mostrarBotonVerde]="false">
    </app-lfsa-botones-formulario>
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      </div>
    </div>
  </ng-template>

  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista==='ListaExtractos'"
                    [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formularioExtractos" class="form-group" novalidate>
      <div class="row">
        <div class="col-md-12 mb-4">
          <div class="form-group col-md-2">
            <app-lfsa-combo-box (change)="getExtractos(rowSelected)" [comboBox]="cmbEan14"
                                [control]="this.formularioExtractos.get('idBanco') | formControl" [idOpcion]="'idBanco'"
                                [id]="'idBanco'"
                                [label]="'Banco'" [opcion]="'dscaBanco'"
                                formControlName="idBanco"></app-lfsa-combo-box>
          </div>
        </div>
      </div>
    </form>
    <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                 [formularioValido]="validateForm()"
                                 [loading]="loading"
                                 [textBoton]="textBoton"
    >
    </app-lfsa-botones-formulario>
    <div class="row">
      <div class="col-md-12 ">
        <!--        <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>-->
        <ag-grid-angular #agGrid (gridReady)="onGridReadyExtractos($event)" [columnDefs]="columnDefsExtractos"
                         [floatingFilter]="true" [frameworkComponents]="frameworkComponentsExtractos"
                         [ngStyle]="diccionarioModulo.agGrid.style"
                         [paginationPageSize]="diccionarioModulo.agGrid.paginacion" [pagination]="true"
                         [rowData]="rowDataExtractos"
                         [rowSelection]="rowSelectionExtractos"
                         [suppressRowClickSelection]="true" class="{{diccionarioModulo.agGrid.class}}"
                         id="{{diccionarioModulo.agGrid.idExtractos}}">
        </ag-grid-angular>
      </div>
    </div>
  </ng-template>
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista && mostrarGridLista ==='ListaCobros'"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplate>
    <section class="section">
      <form [formGroup]="formulario" class="form-group" novalidate>
        <div class="row mb-4">
          <div class="form-group col-12 col-md-4">
            <app-lfsa-combo-box (change)="getLineaPlanta()" [mostrarImg]="false" [rutaImagen]="''"
              [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbPlanta" formControlName="planta"
              [control]="formulario.get('planta')" [label]="'Planta'" [id]="'planta'">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-12 col-md-4">
            <app-lfsa-combo-box [mostrarImg]="false" [rutaImagen]="''"
              [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbLinea" formControlName="linea"
              [control]="formulario.get('linea')" [label]="'Línea'" [id]="'linea'">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('fechaIni') | formControl"
                            (change)='obtainDate()'
                            [id]="'fechaIni'"
                            [label]="'Fecha Inicio*'" [mostrarImg]="false" [placeholder]="'Fecha'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fechaIni">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('fechaFin') | formControl"
                            (change)='obtainDate()'
                            [id]="'fechaFin'"
                            [label]="'Fecha Fin*'" [mostrarImg]="false" [placeholder]="'Fecha'"
                            [rutaImagen]=""
                            [type]="'date'"
                            formControlName="fechaFin">
            </app-lfsa-input>
          </div>
          <div class="form-group col-md-8">
            <app-lfsa-combo-box [comboBox]="cmbEan14"
                                (change)='obtainReceta($event)'
                                [control]="this.formulario.get('ean14') | formControl" [idOpcion]="'clave'"
                                [id]="'ean14'"
                                [label]="'Material y Ean14'" [opcion]="'valor'"
                                formControlName="ean14"></app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-combo-box [comboBox]="cmbReceta"
                                [control]="this.formulario.get('receta') | formControl" [idOpcion]="'clave'"
                                [id]="'receta'"
                                [label]="'Receta'" [opcion]="'valor'"
                                formControlName="receta"></app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-combo-box [comboBox]="cmbLote"
                                [control]="this.formulario.get('lote') | formControl" [idOpcion]="'clave'"
                                [id]="'lote'"
                                [label]="'Lote'" [opcion]="'valor'"
                                formControlName="lote"></app-lfsa-combo-box>
          </div>
        </div>
        <div class="row mb-4">
          <div class="form-group col-md-8">
            <br>
            <button (click)="generarGaussReport()"
            [disabled]="formulario.invalid"
            class="{{DAT_BTNCSS.primary}}">{{ DAT_BTNS.buscar }}
            </button>
          </div>
          <div class="form-group col-md-2">
            <br>
            <button [disabled]="gaficoCompLoading" *ngIf="!loading" class="btn btn-success btn-block"  (click)="generateDetailedCSV()" >
              <i class="fa fa-download" aria-hidden="true"></i></button>
          </div>
          <div class="form-group col-md-2">
            <app-lfsa-input [control]="formulario.get('tolerancia') | formControl"
                            [id]="'tolerancia'"
                            [label]="'Tolerancia %'" [mostrarImg]="false" [placeholder]="'15'"
                            [rutaImagen]=""
                            [type]="'number'"
                            formControlName="tolerancia">
            </app-lfsa-input>
          </div>
        </div>
      </form>
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      <div class="row">
        <div class="col-md-4 ">
          <div class="d-grid gap-4">
            <button type="button" class="btn btn-info btn-lg"><b> {{ truncator(this.pesoSap,2) }} </b> <br> {{ this.textPeso }}</button>
          </div>
        </div>
        <div class="col-md-4 ">
          <div class="d-grid gap-4">
            <button type="button" class="btn btn-success btn-lg"> <b> {{ truncator(promedio,2) }} </b> <br> Promedio </button>
          </div>
        </div>
        <div class="col-md-4 ">
          <div class="d-grid gap-4">
            <button type="button" class="btn btn-warning btn-lg"><b> {{ truncator(desviacionStd,2) }} </b> <br>  Desviación estándar </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-gh-campana-gauss
                        *ngIf="!gaficoCompLoading"
                        [dataList]="data_grafico_compuesto"
                        [loading]=""
                        [idComponent]="'idProdpro'"
                        [title]="'Campana de Gauss'"
                        [pesoReferencial]="pesoSap"
                        [minimo]="minimo"
                        [maximo]="maximo"
                        ></app-lfsa-gh-campana-gauss>
        </div>
      </div>
      <br>
      <div class="row" *ngIf="!gaficoCompLoading">
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <label>&nbsp;</label>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div  style ="text-align:center;">
              <label><b>Minimo</b></label>
            </div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div  style ="text-align:center;">
              <label><b>Promedio</b></label>
            </div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div  style ="text-align:center;">
              <label><b>Referencia</b></label>
            </div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div  style ="text-align:center;">
              <label><b>Maximo</b></label>
            </div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div  style ="text-align:center;">
              <label><b>Desv.Std / Cajas</b></label>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row" *ngIf="!gaficoCompLoading">
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">DATOS CAPTURA</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">{{ (truncator(minimoAxis,2)).toFixed(2) }}<->{{ truncator(((promedio-minimoAxis)/promedio)*100,2).toFixed(2) }}%</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">{{ (truncator(promedio,2)).toFixed(2) }}</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">&nbsp;</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">{{ (truncator(maximoAxis,2)).toFixed(2) }}<->{{ truncator(((maximoAxis-promedio)/promedio)*100,2).toFixed(2) }}%</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">{{ (truncator(desviacionStd,2)).toFixed(2) }}</div>
          </div>
        </div>
      </div>
      <br>
      <div class="row" *ngIf="!gaficoCompLoading">
        <div class="col-md-2">
          <div class="d-grid gap-2">
            <div id="apartado1">
              DATOS BASE
            </div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">{{ (pesoSap - (pesoSap*minimo)).toFixed(2) }}<->{{ (minimo*100).toFixed(2) }}%</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">&nbsp;</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">{{ truncator(pesoSap,2).toFixed(2) }}</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">{{ ((pesoSap*1)+(pesoSap*maximo)).toFixed(2) }}<->{{ (maximo*100).toFixed(2) }}%</div>
          </div>
        </div>
        <div class="col-md-2 ">
          <div class="d-grid gap-2">
            <div id="apartado1">{{numeroRegistros}} cj</div>
          </div>
        </div>
      </div>
      <div *ngIf="mostrarTabla" class="row">
        <div class="col-md-12 ">
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion"
                           [pagination]="true" [rowData]="rowData"
                           [rowSelection]="rowSelection" class="{{diccionarioModulo.agGrid.class}}"
                           id="{{diccionarioModulo.agGrid.id}}">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
